<template>
  <div class="video-container">
    <video ref="videoRef" class="video-container" :src="src" :poster="poster" @click.stop="handleClickVideo"></video>
    <img
      v-if="!playing"
      class="play-icon"
      src="https://logo.wondercv.com/banners/RdxU4QviU5geiL3.png"
      alt=""
      @click.stop="handleClickVideo" 
    />
  </div>
</template>
<script>
export default {
  props: {
    src: String,
    poster: String,
    activeIndex: Number
  },
  data() {
    return {
      playing: false
    }
  },
  watch: {
    activeIndex() {
      this.$refs.videoRef.pause()
      this.playing = false;
    }
  },
  methods: {
    handleClickVideo() {
      if (this.playing) {
        this.$refs.videoRef.pause()
        this.playing = false
      } else {
        this.$refs.videoRef.play()
        this.playing = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    z-index: 10;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
